export default __webpack_public_path__ + "550b445dea48ecfe1b1d9c2018af4be1.svg";